import React from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';
import { appConfig } from '../../utils/appConfig';
import ButcherPaper from '../ButcherPaper';

interface Props {
  white?: boolean;
  dark?: boolean;
  brandBackground?: boolean;
  black?: boolean;
  texture?: boolean;
  butcherPaper?: boolean;
  backgroundImageUrl?: string | null;
  children: React.ReactNode;
  className?: string;
  height?: string;
  basePadding?: boolean;
  largePadding?: boolean;
  gutterX?: boolean;
  gutterY?: boolean;
  zIndexNone?: boolean;
  rootRef?: any;
  [val: string]: any;
}

const Section = ({
  butcherPaper,
  children,
  basePadding,
  largePadding,
  rootRef,
  className,
  darkGray,
  white,
  black,
  dark,
  brandBackground,
  zIndexNone,
  backgroundImageUrl,
  gutterY,
  gutterX,
  texture,
  componentHeight,
  dataTestId,
  ariaLabel,
  as: Element = 'div',
  role = null,
}: Props) => {
  return (
    <Element
      data-testid={dataTestId}
      aria-label={ariaLabel}
      className={classNames(
        dark && butcherPaper && 'bg-neutral-600',
        dark && !butcherPaper && 'bg-neutral-700',
        brandBackground && !butcherPaper && appConfig.isMeater && 'bg-brand-300',
        white && 'bg-neutral-100',
        black && 'bg-neutral-800',
        darkGray && 'bg-neutral-600',
        zIndexNone ? 'z-0' : 'z-[100]',
        backgroundImageUrl && 'bg-cover bg-no-repeat bg-center',
        gutterX && 'px-gutterXS sm:px-gutterLG',
        gutterY && 'py-gutterXS sm:py-gutterLG',
        basePadding && 'py-2 sm:py-3',
        largePadding && 'py-3 sm:py-4',
        texture && appConfig.isTraeger && 'bg-speckle bg-fixed',
        texture && appConfig.isMeater && 'bg-blackSlateBackground bg-fixed',
        !dark && !white && !black && !darkGray && !brandBackground && 'bg-warm-100',
        className,
        'section relative h-full [&_.section]:bg-transparent',
      )}
      style={{
        backgroundImage: (backgroundImageUrl && `url(${backgroundImageUrl})`) ?? '',
        height: componentHeight && `${componentHeight}`,
      }}
      ref={rootRef}
      role={role}
    >
      {butcherPaper && <ButcherPaper className={classNames('butcher-paper')} />}
      {children}
    </Element>
  );
};

export default Section;
